import { render, staticRenderFns } from "./insuranceManage.vue?vue&type=template&id=07150f7c&scoped=true"
import script from "./insuranceManage.vue?vue&type=script&lang=js"
export * from "./insuranceManage.vue?vue&type=script&lang=js"
import style0 from "./insuranceManage.vue?vue&type=style&index=0&id=07150f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07150f7c",
  null
  
)

export default component.exports